import PropTypes from 'prop-types';

/**
 * @deprecated Use TypeScript instead.
 */
export default PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
